import { useEffect } from 'react';

export const useTailwindFlag = () => {
  useEffect(() => {
    const htmlElement = document.documentElement;
    /**
     * Adds the `data-ui2` attribute to the HTML element so that you can utilize
     * the `ui2:className` tailwind variant.
     */
    htmlElement.setAttribute('data-ui2', '');
  }, []);
};
